import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cloudscale': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M318.1 154c6.2-6.3 15.8 3.1 9.5 9.6l-75.2 88.8c0.9 8.2-1.8 16.8-8.1 23.1-11.1 11-28.9 11-40 0-11.1-11.1-11.1-29 0-40 6.3-6.3 14.8-9 23.1-8.1l25.2-20.4c-16.4-15.3-38.4-24.7-62.6-24.7-50.8 0-94.6 41.4-92.6 97.4-1-6.3-1.4-12.8-1.4-19.4 0-71.5 57.8-132.3 129.4-132.3 31.8 0 60.8 14.3 83.3 33.6zM234.3 265.5c5.6-5.5 5.6-14.6 0-20.2-5.6-5.6-14.6-5.6-20.2 0-5.6 5.6-5.6 14.6 0 20.2 5.6 5.5 14.6 5.5 20.2 0zM224 32c123.5 0 224 100.5 224 224s-100.5 224-224 224-224-100.5-224-224 100.5-224 224-224zM224 416c88.2 0 160-71.8 160-160s-71.8-160-160-160-160 71.8-160 160 71.8 160 160 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cloudscale.js
// module id = 757
// module chunks = 0